import { CopilotApiService } from './lib/services/copilot.service';
import { provideState, Store } from '@ngrx/store';
import { copilotReducer } from './lib/store/copilot.reducer';
import { provideEffects } from '@ngrx/effects';
import { CopilotEffects } from './lib/store/copilot.effects';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideAdminSectionEntry } from '@brighthub/admin-contract';
import { CopilotFacadeService } from './lib/services/copilot-facade.service';

export * from './lib/store/copilot.actions';
export * from './lib/store/copilot.reducer';
export * from './lib/store/copilot.selectors';
export * from './lib/store/copilot.effects';
export * from './lib/services/copilot.service';
export * from './lib/services/copilot-facade.service';
export * from './lib/models/copilot.models';
export * from './lib/components/chat/chat.component';
export * from './lib/components/chat-suggestions-bar/chat-suggestions-bar.component';
export * from './lib/components/chat-suggestions-admin/chat-suggestions-admin.component';
export * from './lib/models/chat-suggestions-api.model';
export * from './lib/models/chat-suggestions-admin.model';
export * from './lib/services/chat-suggestions-admin.service';
export * from './lib/services/chat-suggestions.service';
export * from './lib/config/chat-suggestion-agents.config';
export * from './lib/btm/conversational-btm.models';
export * from './lib/btm/conversational-btm-events';
export * from './lib/btm/conversational-btm-api.service';
export * from './lib/btm/sse-parser';
export * from './lib/btm/run-message-reducer';
export * from './lib/btm/conversation-message.mapper';
export * from './lib/connectors/connector.models';
export * from './lib/connectors/connector-api.service';
export * from './lib/connectors/agent-connector-requirements.service';
export * from './lib/connectors/connector-oauth.service';
export * from './lib/connectors/connector-auto-reconnect.service';
export * from './lib/connectors/connector-state.service';
export * from './lib/connectors/connector-status.component';

/**
 * Registers NgRx copilot state/effects and contributes a suggestion-chips entry to the
 * BrightNav admin dashboard via `provideAdminSectionEntry` from `@brighthub/admin-contract`.
 */
export function provideCopilot(): EnvironmentProviders {
  return makeEnvironmentProviders([
    Store,
    CopilotApiService,
    CopilotFacadeService,
    provideState({ name: 'copilot', reducer: copilotReducer }),
    provideEffects([CopilotEffects]),
    provideAdminSectionEntry({
      id: 'chatSuggestions',
      title: 'Suggestion chips',
      description:
        'Create, read, update, and delete chat suggestion chips for the copilot session (fa-app-service admin API).',
      order: 10,
      routerLink: ['suggestions'],
    }),
  ]);
}
